import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { reportAnswers as reportAnswersSelector, updateReportAnswers } from '../../../../../reducers/reportSlice';
import { storageHelper } from '../../../../../helpers/storageHelper';
import ToggleSwitchSection from "./ToggleSwitchSection";
import ContactInfoControlForm from "./ContactInfoControlForm";
import ContactInfoControlSelector from "./ContactInfoControlSelector";

export default function ContactInfoControl({ control, 
                                             shouldStateBeUpdated, 
                                             stateUpdateOptions, 
                                             isContactInfoRequiredByRadioGroupOptions = false,
                                             isShortFormSelected }) {
    const reportAnswers = useSelector(reportAnswersSelector);
    const storedContactInfo = storageHelper.getStoredContactInfo();
    const [isUserContactInfoIncluded, setIsUserContactInfoIncluded] = useState(true);
    const [contactInfo, setContactInfo] = useState(reportAnswers?.contactInfo
        ? reportAnswers?.contactInfo
        : (control.UseStoredContactInfo && storedContactInfo)
            ? { ...storedContactInfo, 
                isIncluded: (control.IsRequired || isContactInfoRequiredByRadioGroupOptions),
                isUserContactInfoIncluded 
            }
            : {
                firstName: "",
                lastName: "",
                email: "",
                phoneNumber: "",
                isIncluded: (control.IsRequired || isContactInfoRequiredByRadioGroupOptions),
                isUserContactInfoIncluded
            });
    const dispatch = useDispatch();

    useEffect(() => {
        if (control.IsRequired || isContactInfoRequiredByRadioGroupOptions) {
            setContactInfo({ ...contactInfo, isIncluded: true })
        }
    }, [isContactInfoRequiredByRadioGroupOptions])

    useEffect(() => {
        if ((shouldStateBeUpdated && contactInfo.isIncluded) || 
            (contactInfo.isIncluded && isShortFormSelected)) {
            dispatch(updateReportAnswers({
                ...reportAnswers,
                contactInfo
            }));
        }
    }, [shouldStateBeUpdated, stateUpdateOptions, contactInfo])

    return (
        <div className="contact-info-control">
            <div className={isShortFormSelected ? "section__header short-form" : "section__header"}>{(control.IsRequired || isContactInfoRequiredByRadioGroupOptions) ? "Include your contact info (REQUIRED*)" : "Include your contact info? (OPTIONAL)"}</div>
            <ContactInfoControlSelector
                control={control}
                isContactInfoRequiredByRadioGroupOptions={isContactInfoRequiredByRadioGroupOptions}
                contactInfo={contactInfo}
                setContactInfo={setContactInfo}
            />

            {contactInfo.isIncluded &&
                <ContactInfoControlForm
                    control={control}
                    isContactInfoRequiredByRadioGroupOptions={isContactInfoRequiredByRadioGroupOptions}
                    setContactInfo={setContactInfo}
                    contactInfo={contactInfo}
                />}

            <ToggleSwitchSection
                isShortFormSelected={isShortFormSelected}
                isUserContactInfoIncluded={isUserContactInfoIncluded}
                setIsUserContactInfoIncluded={setIsUserContactInfoIncluded}
                setContactInfo={setContactInfo}
                contactInfo={contactInfo}
            />
        </div>
    )
}